const pilots = {
  krzysztof: {
    name: 'Krzysztof',
    image: 'https://coolturystki.pl/lib/wyfaqa/krzysztof-coolturystki-strona-marketing-wyjazdy-mjpw9geu.webp',
    details: {
      title: 'O Krzysztofie',
      description:
        'Lubi odkrywać nowe miejsca i dzielić się radością z podróżowania. Podczas wyjazdów dba o dobrą organizację, spokojny przebieg programu i pozytywną atmosferę w grupie.',
    },
  },

  krzysiekAurelia: {
    name: 'Krzyś i Aurelia',
    image: 'https://coolturystki.pl/lib/wyfaqa/coolturystki-piloci-krzysztof-i-aurelia-butikowe-wyjazdy-m8utj8tv.webp',
    imagePosition: 'center 30%',
    nameFontSize: '14px',
    nameLetterSpacing: '-0.25px',
    label: 'Piloci wyjazdu',
    details: {
      title: 'O Krzyśku i Aurelii',
      description:
        'Aurelia jest fotografką, współzałożycielką CoolTurystek i miłośniczką podróży z plecakiem. Krzysiek wnosi do zespołu spokój, świetną organizację i strategiczne myślenie. Razem zadbają o dobrą atmosferę i sprawny przebieg programu.',
    },
  },

  rafal: {
    name: 'Rafał',
    image: 'https://coolturystki.pl/lib/wyfaqa/rafal-pilot-wyjazdow-biura-podrozy-coolturystki-msd4w86k.webp',
    details: {
      title: 'O Rafale',
      description:
        'Jest germanistą, tłumaczem i doświadczonym pilotem z dużym poczuciem humoru. Łączy spokój i profesjonalizm, dba o logistykę oraz sprawny przebieg programu.',
    },
  },

  pawel: {
    name: 'Paweł',
    image: 'https://coolturystki.pl/lib/wyfaqa/pawel-pilot-wycieczek-butikowego-biura-podrozy-coolturystki-mjra6oq3.webp',
    details: {
      title: 'O Pawle',
      description:
        'Jest miłośnikiem podróży, technologii i praktycznych rozwiązań. Lubi dobrą organizację, ciekawe rozmowy i dba o sprawny przebieg wyjazdu oraz komfort grupy.',
    },
  },

  marta: {
    name: 'Marta',
    image: 'https://coolturystki.pl/lib/wyfaqa/marta-coolturystki-wyjazdy-obsluga-biura-mjpw9hoo.webp',
    details: {
      title: 'O Marcie',
      description:
        'Lubi podróże z historią w tle, lokalne smaki i odrobinę sztuki. Podczas wyjazdu dba o dobrą organizację, spokojne tempo i atmosferę w grupie.',
    },
  },

  paulina: {
    name: 'Paulina',
    image: 'https://coolturystki.pl/lib/wyfaqa/paulina-pilotka-coolturystki-wyjazdy-dla-kobiet-metvxioa.webp',
    details: {
      title: 'O Paulinie',
      description:
        'Na co dzień tworzy sztukę tatuażu, a w podróżach szuka natury, ruchu i nowych inspiracji. Jako pilotka czuwa nad organizacją wyjazdu i zachęca grupę do uważnego, kreatywnego odkrywania świata.',
    },
  },

  iza: {
    name: 'Iza',
    image: 'https://coolturystki.pl/lib/wyfaqa/Iza-pilotka-wyjazdow-butikowego-biura-podrozy-mlo73lci.webp',
    details: {
      title: 'O Izie',
      description:
        'Z CoolTurystkami niemal od początku. Jest dziennikarką publikującą w „Wysokich Obcasach” i „Newsweeku”, a podczas podróży łączy ciekawość świata i talent do opowiadania z troską o organizację oraz komfort grupy.',
    },
  },

  dorota: {
    name: 'Dorota',
    image: 'https://coolturystki.pl/lib/wyfaqa/dorota-coolturystki-wspolzalozycielka-planowanie-podrozy-mjpw9dxa.webp',
    details: {
      title: 'O Dorocie',
      description:
        'Jest współzałożycielką CoolTurystek i pasjonatką podróży, która najlepiej czuje się w drodze, odkrywając nowe miejsca i poznając lokalne kultury. Kolekcjonuje perfumy, a podczas wyjazdów dba o logistykę i sprawną realizację programu.',
    },
  },
}

export function getPilotById(pilotId) {
  return pilots[pilotId] ?? null
}
